module.exports = __webpack_public_path__ + "static/media/LI.c02b4b74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LI.svg
// module id = 299
// module chunks = 0